import React, { useRef } from 'react';
import { observer } from 'mobx-react';

import { loc } from '../../lib/loc';
import { useStores } from '../../hooks/use-stores';
import { RegisterLoc } from '../../loc/register';

import PreloadButton from '../../interface/PreloadButton';
import ErrorMessage from '../../interface/ErrorMessage';

const CompanySearchForm = observer(() => {
    const { RegisterStore: store } = useStores();
    const { searchCompany, loaderSearch, errorMessage } = store || {};

    const tinRef = useRef();

    const search = e => {
        e.preventDefault();
        searchCompany(tinRef.current.value);
    };

    return (
        <form className="legal-form__content" onSubmit={search}>
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <input
                className="legal-form__input"
                ref={tinRef}
                style={{ width: '100%' }}
                name="tin"
                placeholder={loc(RegisterLoc.form.tin)}
                required
            />
            <div className="legal-form__wrap-btn">
                <PreloadButton className="legal-form__btn" isLoad={loaderSearch}>
                    {loc(RegisterLoc.buttonSearch)}
                </PreloadButton>
            </div>
        </form>
    );
});

export default CompanySearchForm;
